import React from 'react';
import {StorageKey} from "../../../enums/StorageKey";
import {t} from "@lingui/macro";
import {AmountTdWidth} from "../../Table/Common/AmountTd";
import {
    AccountCell,
    AccountCodeCell,
    AmountCell,
    SystemTypeCell,
} from "../../../containers/AppPage/Accounting/Accounts/Cell/cell";
import AccountListMenu from "../../ListMenu/Account";
import {ActionTdWidth} from "../../Table/Common/CommonWidths";

function getColumns() {
    return [
        {
            title: t`Code`,
            dataIndex: 'code',
            key: 'code',
            width: 60,
            onCell: record => ({
                colSpan: record.is_heading ? 5 : 1,
                className: record.is_heading ? 'subsection-col' : null,
            }),
            render: (text, record) => <AccountCodeCell record={record} />,
        },
        {
            title: t`Account`,
            dataIndex: 'name',
            key: 'name',
            width: 100,
            onCell: record => ({
                colSpan: record.is_heading ? 0 : 1,
            }),
            render: (text, record) => <AccountCell text={text} record={record} />,
        },
        {
            title: t`System Account`,
            dataIndex: 'system_type',
            key: 'system_type',
            width: 160,
            onCell: record => ({
                colSpan: record.is_heading ? 0 : 1,
            }),
            render: (value, record) => <SystemTypeCell record={record} />,
        },
        {
            title: t`Balance`,
            dataIndex: 'balance',
            key: 'balance',
            align: 'right',
            width: AmountTdWidth,
            onCell: record => ({
                colSpan: record.is_heading ? 0 : 1,
            }),
            render: (text, record) => <AmountCell text={text} record={record} />,
        },
        {
            title: t`Action`,
            key: 'action',
            className: 'col-action',
            width: ActionTdWidth,
            onCell: record => ({
                colSpan: record.is_heading ? 0 : 1,
            }),
            render: (text, record) => <AccountListMenu record={record} />,
        },
    ];
}

export default {
    storageKey: StorageKey.chart_accounts,
    sortable: [
        'code',
        'name',
        'balance',
    ],
    required: [
        'code',
        'name',
        'system_type',
        'balance',
        'action',
    ],
    defaulto: [

    ],
    getColumns,
};
